import { images } from "../../../Assets/assetsHelper";
import "./Transactions.css";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Paper,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import config from "../../../config";
import { CheckCircle, Error } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const ResultCard = styled(Card)(({ theme }) => ({
  maxWidth: 500,
  margin: "1rem auto",
  padding: "2rem",
  textAlign: "center",
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
}));

const IconWrapper = styled(Box)(({ theme, success }) => ({
  marginBottom: "1rem",
  "& svg": {
    fontSize: "4rem",
    color: success ? "green" : "#d32f2f",
  },
}));

const DetailItem = styled(Box)(({ theme }) => ({
  margin: "1rem 0",
  padding: "0.5rem",
  backgroundColor: "#f5f5f5",
  borderRadius: "5px",
}));

function TransactionResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const isSuccess = searchParams.get("success") === "true";
  const transactionId = searchParams.get("transactionId");
  const transactionDateTime = searchParams.get("transactionDateTime");
  const transactionNetAmountCents = searchParams.get(
    "transactionNetAmountCents"
  );
  const transactionTotalAmountCents = searchParams.get(
    "transactionTotalAmountCents"
  );
  const transactionCurrencyCode = searchParams.get("transactionCurrencyCode");
  const transactionPaymentMethod = searchParams.get("transactionPaymentMethod");

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="mainContainer">
      <ResultCard>
        <IconWrapper success={isSuccess}>
          {isSuccess ? <CheckCircle /> : <Error />}
        </IconWrapper>

        <Typography variant="h4" gutterBottom>
          {isSuccess ? "Payment Successful!" : "Payment Failed"}
        </Typography>

        {isSuccess ? (
          <>
            <DetailItem>
              <Typography variant="subtitle2" color="textSecondary">
                Transaction ID
              </Typography>
              <Typography variant="body1">{transactionId}</Typography>
            </DetailItem>

            <DetailItem>
              <Typography variant="subtitle2" color="textSecondary">
                Amount Paid
              </Typography>
              <Typography variant="h5">
                {(transactionNetAmountCents / 100).toFixed(2)}{" "}
                {transactionCurrencyCode}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Total Amount: {(transactionTotalAmountCents / 100).toFixed(2)}{" "}
                {transactionCurrencyCode}
              </Typography>
            </DetailItem>

            <DetailItem>
              <Typography variant="subtitle2" color="textSecondary">
                Payment Method
              </Typography>
              <Typography variant="body1">
                {transactionPaymentMethod}
              </Typography>
            </DetailItem>

            <DetailItem>
              <Typography variant="subtitle2" color="textSecondary">
                Transaction Time
              </Typography>
              <Typography variant="body1">
                {formatDate(transactionDateTime)}
              </Typography>
            </DetailItem>

            <Button
              variant="contained"
              onClick={() => navigate("/transactions")}
              sx={{
                mt: 3,
                backgroundColor: config.PRIMARY_COLOR,
                "&:hover": {
                  backgroundColor: config.PRIMARY_COLOR,
                  opacity: 0.9,
                },
              }}
            >
              View All Transactions
            </Button>
          </>
        ) : (
          <>
            <Typography variant="body1" color="error" sx={{ mb: 2 }}>
              An error occurred during payment
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate("/transactions")}
              sx={{
                mt: 2,
                backgroundColor: config.PRIMARY_COLOR,
                "&:hover": {
                  backgroundColor: config.PRIMARY_COLOR,
                  opacity: 0.9,
                },
              }}
            >
              Try Again
            </Button>
          </>
        )}
      </ResultCard>
    </div>
  );
}

export default TransactionResult;
